<template>
  <div class="login-dark-theme">
    <div class="login-container">
      <div class="card login-card">
        <div class="card-body p-4">
          <div class="text-center mb-4">
            <p class="text-muted">
              Enter your username and password to access admin panel.
            </p>
          </div>

              <div class="mb-2">
                <label for="emailaddress" class="form-label"
                  >Username<span class="text-primary">*</span></label
                >
                <input
                  class="form-control"
                  type="text"
                  v-model="username"
                  placeholder="Username"
                />
                <span class="text-primary" v-if="errors && errors.username">{{
                  errors.username[0]
                }}</span>
              </div>

              <div class="mb-2">
                <label for="password" class="form-label"
                  >Password<span class="text-primary">*</span></label
                >
                <div class="input-group input-group-merge">
                  <input
                    type="password"
                    class="form-control"
                    v-model="password"
                    placeholder="Password"
                  />
                </div>
                <span class="text-primary" v-if="errors && errors.password">{{
                  errors.password[0]
                }}</span>
              </div>

              <label class="form-check-label text-primary" v-if="error_msg">
                {{ error_msg }}
              </label>
              <div class="mb-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="checkbox-signin"
                    checked
                  />
                  <label class="form-check-label" for="checkbox-signin">
                    Remember me
                  </label>
                </div>
              </div>

              <div class="d-grid mb-0 text-center">
                <button
                  class="btn btn-primary"
                  v-if="!loader"
                  @click="login()"
                  type="button"
                >
                  Log In
                </button>
                <center>
                  <b-spinner v-if="loader" variant="success"></b-spinner>
                </center>
              </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end page -->
</template>
<script>
export default {
  name: "LoginView",
  data() {
    return {
      username: null,
      password: null,
      errors: [],
      error_msg: null,
      loader: false,
    };
  },
  methods: {
    login() {
      //Save or update User Details
      this.errors = [];
      this.error_msg = null;
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "api/login";
      let method_type = "post";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          username: this.username,
          password: this.password,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === true) {
            var userData = {
              user: data.user,
              user_type: data.user_type,
              token: data.token,
              status: true,
            };
            localStorage.setItem("userData", JSON.stringify(userData));
            window.location.href = "/admin/dashboard";
          } else if (data.status === false) {
            localStorage.clear();
            this.error_msg = data.message;
          } else {
            this.errors = data.errors;
          }
          this.loader = false;
        })
        .catch(function (err) {
          console.log("Login Data", "Error : " + err.message, "error");
        });
    },
  },
};
</script>

<style scoped>
/* Dark Green Login Theme */
.login-dark-theme {
  min-height: 100vh;
  background: 
    radial-gradient(circle at 20% 80%, rgba(16, 185, 129, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(6, 214, 160, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(52, 211, 153, 0.05) 0%, transparent 50%),
    linear-gradient(135deg, #0F172A 0%, #1E293B 100%);
  background-size: 100% 100%, 100% 100%, 100% 100%, 100% 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Inter', sans-serif;
  overflow: hidden;
}

.login-dark-theme::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(2px 2px at 20px 30px, rgba(16, 185, 129, 0.3), transparent),
    radial-gradient(2px 2px at 40px 70px, rgba(6, 214, 160, 0.2), transparent),
    radial-gradient(1px 1px at 90px 40px, rgba(52, 211, 153, 0.4), transparent),
    radial-gradient(1px 1px at 130px 80px, rgba(16, 185, 129, 0.2), transparent),
    radial-gradient(2px 2px at 160px 30px, rgba(6, 214, 160, 0.3), transparent);
  background-repeat: repeat;
  background-size: 200px 100px;
  animation: fishFloat 20s ease-in-out infinite;
  opacity: 0.6;
}

@keyframes fishFloat {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-10px) rotate(1deg); }
}

.login-container {
  width: 100%;
  max-width: 450px;
  padding: 20px;
}

.login-card {
  background: #1E293B !important;
  border: 1px solid #334155 !important;
  border-radius: 20px !important;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4) !important;
  backdrop-filter: blur(15px) !important;
  width: 100%;
}

.login-dark-theme .card-body {
  background: transparent !important;
  color: #F1F5F9 !important;
  padding: 2rem !important;
}

.login-dark-theme .text-muted {
  color: #94A3B8 !important;
}

.login-dark-theme .form-label {
  color: #F1F5F9 !important;
  font-weight: 500 !important;
}

.login-dark-theme .form-control {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
  border-radius: 8px !important;
  color: #F1F5F9 !important;
  padding: 12px 16px !important;
  transition: all 0.3s ease !important;
}

.login-dark-theme .form-control:focus {
  background: #0F172A !important;
  border-color: #10B981 !important;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1) !important;
  color: #F1F5F9 !important;
}

.login-dark-theme .form-control::placeholder {
  color: #64748B !important;
}

.login-dark-theme .text-primary {
  color: #10B981 !important;
}

.login-dark-theme .btn-primary {
  background: linear-gradient(135deg, #10B981, #059669) !important;
  border: none !important;
  border-radius: 8px !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 12px 24px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
}

.login-dark-theme .btn-primary:hover {
  background: linear-gradient(135deg, #059669, #047857) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4) !important;
}

.login-dark-theme .form-check-label {
  color: #94A3B8 !important;
}

.login-dark-theme .form-check-input:checked {
  background-color: #10B981 !important;
  border-color: #10B981 !important;
}

.login-dark-theme .form-check-input:focus {
  border-color: #10B981 !important;
  box-shadow: 0 0 0 0.25rem rgba(16, 185, 129, 0.25) !important;
}

/* Logo styling */
.login-dark-theme .auth-logo img {
  filter: brightness(1.2) !important;
}

/* Spinner styling */
.login-dark-theme .spinner-border {
  color: #10B981 !important;
}

/* Responsive */
@media (max-width: 768px) {
  .login-dark-theme .card {
    margin: 20px !important;
  }
}
</style>